// Third-party
import React from 'react';

// Components
import AddEnterpriseMemberForm from '../forms/AddEnterpriseMemberForm';
import Modal from '@/views/components/modals/AccessibleModal';

type Props = {
  show: boolean;
  onCancel: () => void;
  onSave: (fname: string, lname: string, email: string) => void;
};

const AddDelegateModal = (props: Props) => (
  <Modal show={props.show} className="add-enterprise-member-modal" onHide={props.onCancel} dialogClassName="modal-dialog-centered">
    <AddEnterpriseMemberForm
      onAddMember={props.onSave}
      onCancel={props.onCancel}
      titleTextKey="Settings.Delegates.AddDelegate"
      addButtonTextKey="Settings.Delegates.AddDelegateBtn"
      infoTextKey="Settings.Delegates.AddDelegateInfo"
      successTextKey="Settings.Delegates.AddDelegateSuccess"
    />
  </Modal>
);

export default AddDelegateModal;
